// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ncYbZv{position:absolute;top:0;bottom:0;right:0;left:0;background-color:#5d5d5d;color:white;font-size:14px;display:flex;flex-direction:column;text-align:center;justify-content:center}.ncYbZv h1{font-weight:100;font-size:18px;margin:18px;display:inline-block}.ncYbZv a{text-decoration:none;border-bottom:1px solid white;color:white}html[dir='ltr'] .ncYbZv a{margin-right:4px}html[dir='rtl'] .ncYbZv a{margin-left:4px}.ncYbZv a:hover{border-bottom:1px solid transparent}.fQP21h{display:inline-block;font-size:10px}html[dir='ltr'] .fQP21h{transform:rotate(180deg)}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"error": `ncYbZv`,
	"arrow": `fQP21h`
};
export default ___CSS_LOADER_EXPORT___;
